<template>
  <div class="endereco_falecido col-12 m-0 p-0">
    <div class="endereco_falecido_header w-100 p-2 my-2">
      Endereço
    </div>

    <div class="endereco_falecido_body">
      <button v-if="!Object.values(propEndereco).length"
              class="btn_add_endereco btn btn-sm btn-outline-primary btn-block my-3"
              :disabled="propDisabled"
              @click="addAddress">
        <icon-svg icon="add"
                  class="icon-add icon--sm mr-1" />
        Adicionar endereço
      </button>

      <div v-else
           class="endereco_falecido_box my-3 d-inline-flex justify-content-between align-items-center w-100">
        <div class="d-inline-flex">
          <div class="endereco_falecido_box_endereco mx-2">
            <h3 class="endereco_falecido_box_title">
              Endereço completo
            </h3>
            <h3 class="endereco_falecido_box_endereco">
              {{ propEndereco | Endereco }}
            </h3>
          </div>
          <div v-if="pais"
               class="endereco_falecido_box_endereco mx-2">
            <h3 class="endereco_falecido_box_title">
              País
            </h3>
            <h3 class="endereco_falecido_box_endereco">
              {{ pais }}
            </h3>
          </div>
        </div>
        <div class="endereco_falecido_box_acoes mx-2">
          <button class="btn btn-danger btn-sm mx-2"
                  @click="deleteAddress">
            Excluir
          </button>
          <button class="btn btn-primary btn-sm"
                  @click="editAddress">
            Editar
          </button>
        </div>
      </div>
    </div>

    <b-modal :id="`enderecoFalecido`"
             :ref="`enderecoFalecido`"
             :hide-header="true"
             no-close-on-backdrop
             no-close-on-esc
             centered
             size="xl">
      <BoxEndereco
        :prop-mostrar-exterior="true"
        :no-header="true"
        :data="formEndereco"
        @onEnderecoAdd="getAddress" />

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalEditGenitor_footer">
        <button class="btn btn-sm btn-dark mr-2"
                @click="cancel()">
          Voltar
        </button>
        <button class="btn btn-sm btn-secondary"
                type="submit"
                @click="submitAddress">
          {{ Object.values(propEndereco).length ? "Atualizar" : "Adicionar" }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import BoxEndereco from "@/components/SofiaRei/BoxEndereco"
  import NacionalidadesService from "@/services/NacionalidadesService"

  export default {
    name: "EnderecoFalecido",
    components: {
      BoxEndereco
    },
    props: {
      propEndereco: {type: Object, default: () => ({})},
      propCartorio: {type: Object, default: () => ({})},
      propDisabled: {type: Boolean, default: false }
    },
    data () {
      return {
        formEndereco: {
          exterior: false,
          cep: null,
          logradouro: null,
          numero: null,
          complemento: null,
          bairro: null,
          uf: null,
          cidade: null,
          ibge: null,
          atual: true,
          pais: null,
        },
        paises: [],
        pais: null
      }
    },
    watch: {
      propEndereco () {
        if (Object.values(this.propEndereco).length) this.formEndereco = {...this.propEndereco}
        this.pais = this.formEndereco.pais
        this.loadPaises()
      },
      propDisabled () {
        if (this.propDisabled) this.$emit('addAddress', {})
      }
    },
    mounted () {
      this.pais = this.formEndereco.pais
      this.loadPaises()
    },
    methods: {
      addAddress () {
        this.formEndereco = {
          exterior: false,
          cep: null,
          logradouro: null,
          numero: null,
          complemento: null,
          bairro: null,
          uf: null,
          cidade: null,
          ibge: this.propCartorio.endereco ? this.propCartorio.endereco.ibge : null,
          atual: true
        }

        this.$root.$emit('bv::show::modal', `enderecoFalecido`)
      },
      async submitAddress () {
        const valid = await this.$validator.validate()

        const {errors: {items}} = this.$validator
        let emptyNumber = false

        if (items && items.length) {
          emptyNumber = !!items.find(item => item.field == 'numero' || item.field == 'codigo_ibge')
        }

        if (!valid || emptyNumber) return

        this.$emit('addAddress', this.formEndereco)
        this.$root.$emit('bv::hide::modal', `enderecoFalecido`)
      },
      getAddress (endereco) {
        this.formEndereco = {...endereco}
      },
      editAddress () {
        this.formEndereco = {...this.propEndereco}
        this.$root.$emit('bv::show::modal', `enderecoFalecido`)
      },
      deleteAddress () {
        this.$emit('deleteAddress', this.propEndereco)
        this.$emit('addAddress', {})
      },
      async loadPaises () {
        this.paises = await NacionalidadesService.searchNacionalidadeByName("")
        this.getPais()
      },
      getPais () {
        const pais = this.paises.filter(pais => pais.codigo == this.propEndereco.codigo_pais)
        if (pais.length) this.pais = pais[0].nome
      },
    }
  }
</script>
<style lang="scss">
  .btn_add_endereco:hover:not(:disabled) > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 18px;
    height: 18px;
    transition: fill 0.2s;
  }

  .endereco_falecido {
    &_header {
      background: #EAEAEA;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
    }

    &_box {
      box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
      height: 70px;

      &_title {
        font-family: Roboto;
        font-size: 14px;
        font-weight: normal;
        color: #373a3c;
        text-decoration: underline;
      }

      &_endereco {
        font-family: Roboto;
        font-size: 16px;
        font-weight: 500;
        color: #373a3c;
      }
    }
  }
</style>
